var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrScan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9997 0H35.1997V4.39998H43.9997V0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8003 0H57.2003V4.39998H66.0002V8.79996H52.8003V0Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3995 0H74.7995V48.3998H70.3995V39.5998H65.9996V43.9998H61.5979V39.5998H57.1996V35.1998H52.7996V21.9999H48.3996V13.1999H35.1997V8.79996H43.9997V4.39998H48.3996V8.79996H52.7996V13.1999H65.9996V17.5999H57.1996V30.7999H61.5979V26.3999H65.9996V35.1998H70.3995V21.9999H65.9996V17.5999H70.3995V0Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V30.7999H30.7999V0H0ZM26.3999 26.3999H4.39998V4.39998H26.3999V26.3999Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1992 0V30.7999H109.999V0H79.1992ZM105.599 26.3999H83.5992V4.39998H105.599V26.3999Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 8.80029H8.80029V22.0002H22.0002V8.80029Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.199 8.80029H87.9995V22.0002H101.199V8.80029Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1997 17.5996H43.9997V26.3996H39.5997V21.9996H35.1997V17.5996Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1997 26.4004H39.5997V30.8004H43.9997V26.4004H48.3996V35.2003H52.7996V39.6003H57.1996V44.0003H52.7996V48.4003H48.3996V39.6003H43.9997V35.2003H35.1997V26.4004Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8 35.1997H22V39.5997H30.8V35.1997Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3995 35.1997H87.9995V39.5997H92.3995V35.1997Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7998 35.1997H101.2V43.9997H110V57.1996H101.2V48.3996H96.7998V35.1997Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M110 35.1997H105.6V39.5997H110V35.1997Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1994 39.6001H4.39941V44.0001H13.1994V39.6001Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0006 39.6001H17.6006V44.0001H22.0006V39.6001Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39998 43.9995H0V48.3995H4.39998V43.9995Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7989 43.9995H26.3989V48.3995H30.7989V43.9995Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79939 48.3999H17.5994V57.1999H13.1994V61.5998H8.79939V57.1999H4.39941V52.7999H8.79939V48.3999Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4 48.3999H22V52.7999H26.4V48.3999Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4 48.3999H66V52.7999H70.4V48.3999Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7989 52.8003H26.3989V57.2003H30.7989V52.8003Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39998 57.1992H0V74.7991H4.39998V57.1992Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0006 57.1992H17.6006V61.6009H22.0006V57.1992Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5992 61.5996H13.1992V65.9996H17.5992V61.5996Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7989 61.5996H26.3989V65.9996H30.7989V61.5996Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1997 61.5996H39.5997V65.9996H43.9997V74.7995H39.5997V79.1995H35.1997V61.5996Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3988 61.5996H83.6006V65.9996H92.3988V61.5996Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M109.999 61.5996H101.199V65.9996H109.999V61.5996Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0006 66H17.6006V70.4H22.0006V66Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2003 70.3999H8.80029V74.8016H13.2003V70.3999Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8 70.3999H22V74.8016H30.8V70.3999Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3995 74.8003H43.9995V79.2003H48.3995V74.8003Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M110 74.7995V70.3995H101.2V65.9996H92.3997V70.3995H74.7998V65.9996H79.1997V61.5996H83.5997V57.1996H92.3997V61.5996H96.7997V48.3996H92.3997V43.9997H87.9997V48.3996H83.5997V43.9997H87.9997V39.5997H83.5997V35.1997H79.1997V48.3996H74.7998V61.5996H65.9998V52.7996H61.5981V61.5996H57.1981V48.3996H52.7982V57.1996H48.3982V48.3996H35.1982V52.7996H39.5982V61.5996H43.9999V65.9996H48.3999V61.5996H52.7999V65.9996H48.3999V74.7995H52.7999V79.1995H57.1998V70.3995H61.5998V79.1995H65.9998V74.7995H70.3998V79.1995H65.9998V83.5995H61.5981V96.7994H52.7999V101.199H61.5981V105.599H52.7999V109.999H74.7998V105.599H70.3998V101.199H65.9998V87.9995H70.3998V92.3994H74.7998V96.7994H79.1997V92.3994H92.3997V96.7994H96.7997V92.3994H101.2V87.9995H96.7997V79.1995H92.3997V74.7995H110ZM70.3998 70.3995H65.9998V65.9996H70.3998V70.3995ZM87.9997 87.9995H74.7998V74.7995H87.9997V87.9995Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7994 79.1992H48.3994V87.9992H52.7994V79.1992Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6009 79.1992H79.1992V83.6009H83.6009V79.1992Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M110 79.1992H105.6V87.9992H110V79.1992Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 79.1992V109.999H30.7999V79.1992H0ZM26.3999 105.599H4.39998V83.5992H26.3999V105.599Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1997 83.5996H43.9997V92.3996H48.3996V96.7995H43.9997V101.2H39.5997V87.9996H35.1997V83.5996Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 87.999H8.80029V101.199H22.0002V87.999Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2003 87.999H52.8003V92.399H57.2003V87.999Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M110 92.3999H105.6V110H110V92.3999Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8006 96.8003H70.3989V101.2H74.8006V96.8003Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1992 96.8003H87.9992V101.2H96.7991V110H92.3992V105.6H83.5992V110H79.1992V96.8003Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M101.2 96.8003H96.7998V101.2H101.2V96.8003Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7994 101.2H48.3994V105.601H52.7994V101.2Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0006 105.6H39.6006V110H44.0006V105.6Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrScan);
export default __webpack_public_path__ + "static/media/qrScan.0a43acd10f110091e409688f22ae6e9f.svg";
export { ForwardRef as ReactComponent };